import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {PATTERN_DIRECTION_TO_DISPLAY, PatternDirection} from 'samples/plate-maps/PlateMapConstants';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import {GRAY} from 'ui-library/Colors';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import Menu from 'ui-library/menus/Menu';
import {MenuWidth} from 'ui-library/menus/MenuConstants';
import Option from 'ui-library/menus/Option';

/**
 * Dropdown component for selecting a direction to apply a pattern when assigning plate map well data.
 */
export default function PatternDirectionDropdown({
  selectedDirection,
  onSelectDirection,
  label,
  dataTestAttrs,
}: {
  selectedDirection: PatternDirection;
  onSelectDirection: (dir: PatternDirection) => void;
  label: string;
  dataTestAttrs?: DataTestAttrs;
}): JSX.Element {
  return (
    <div>
      <FieldLabel label={label} />
      <SelectDropdown
        menu={
          <Menu value={selectedDirection} width={MenuWidth.FULL}>
            {Object.keys(PatternDirection).map((dir: PatternDirection) => (
              <Option
                key={dir}
                value={dir}
                icon={PATTERN_DIRECTION_TO_DISPLAY[dir].icon}
                onSelect={onSelectDirection}
                iconClassName={css(styles.optionIcon)}
              >
                <p className={css(styles.fillMenuText)}>{PATTERN_DIRECTION_TO_DISPLAY[dir].name}</p>
              </Option>
            ))}
          </Menu>
        }
        displayName={
          <span>
            <BenchlingIcon
              icon={PATTERN_DIRECTION_TO_DISPLAY[selectedDirection].icon}
              className={css(styles.selectionIcon)}
            />
            {PATTERN_DIRECTION_TO_DISPLAY[selectedDirection].name}
          </span>
        }
        alwaysDropDown={true}
        dataTestAttrs={dataTestAttrs}
      />
    </div>
  );
}

const styles = StyleSheet.create({
  optionIcon: {
    marginLeft: 8,
  },
  fillMenuText: {
    marginLeft: 4,
    marginBottom: 0,
  },
  selectionIcon: {
    marginRight: 8,
    color: GRAY,
  },
});
